import { useEffect, useState } from 'react'
import { SBack, STitle } from 'shj-components'
import { useParams } from 'react-router-dom'
import { Card, Col, Form, Rate, Space, Spin } from 'antd'
import { evaluationRecordDetail } from '@/services/evaluateConfig'
import EvaluateRecordInfo from '../components/info'
import RecommendRate from '../components/recommendRate'

const EvaluateRecordDetails = (props: any) => {
    const params = useParams()
    const id = params?.id || ''
    const [form] = Form.useForm();
    const [pageData, setPageData] = useState<any>({})
    const [values, setValues] = useState([])
    const [spinning, setSpinning] = useState<any>(false)
    useEffect(() => {
        getDetail()
    }, [])
    const getDetail = () => {
        setSpinning(true)
        evaluationRecordDetail(id).then((res: any) => {
            if (res) {
                setPageData(res)
                form.setFieldsValue({ evaluationRecords: res.evaluationRecords });
                setValues(res.evaluationRecords);
            }
        }).finally(()=>{
            setSpinning(false)
        })
    }

    const itemListDom = (field: any) => {
        let { key, name, ...restField } = field;
        console.log(values[name])
        return (
            <>
                <Col><span>{values[name]['evaluationTitle']}</span></Col>
                <Form.Item
                    label={''}
                    name='professionalLevel'
                >
                    <Space>
                        <RecommendRate totalCount={values[name]?.evaluationOptions?.['10']?10:5}  isRate={true} recommendedLevel={values[name]?.['starLevel']} disabled={true}/>
                        <div style={{display: 'flex',alignItems: 'center',marginTop: 27}}>
                            <span style={{ padding: '0 10px' }}>{values[name]?.['starLevel'] ?? 0}分</span>
                            <div style={{ color: 'rgb(153,153,153)' }}>{(values[name]?.['starLevelLabel'] ?? []).join('、')}</div>
                        </div>
                    </Space>
                </Form.Item>
            </>
        );
    };
    return (
        <Spin spinning={spinning}>
            <SBack title={'详情'} level={2}>
                <Card bordered={false} style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                    <EvaluateRecordInfo pageData={pageData} timeNum={pageData['timeNum']} />
                    <Form
                        style={{ padding: "10px 0" }}
                        form={form}
                        disabled={true}
                    >
                        <STitle titleMode={'edit'} style={{ marginBottom: 10 }} title={pageData.evaluationTitle} />
                        <Form.List name="evaluationRecords">
                            {(fields) => (
                                <>
                                    {fields.map((field) => {
                                        return itemListDom(field)
                                    })}
                                </>
                            )}
                        </Form.List>
                        <RecommendRate recommendedLevel={pageData.recommendedLevel} disabled={true}/>
                        <Form.Item
                            label={'其他建议或留言：'}
                            name='leaveMsg'
                        >
                            <div style={{ color: 'rgb(153,153,153)' }}>{pageData['leaveMsg']}</div>
                        </Form.Item>
                    </Form>
                </Card>
            </SBack>
        </Spin>
    )
}

export default EvaluateRecordDetails
